import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import { CustomNotification } from 'common/components';
import { getProductIngredients } from 'services/product';
import { saveProductIngredient } from 'services/product';

export const INGREDIENT_KEY = {
  OVERVIEW: 'overview/multiple-panels/get-ingredients',
};

export const getKeyProductIngredients = (id) => {
  return ['pim', 'overview/multiple-panels/get-ingredients', parseInt(id)];
};

export const useQueryProductIngredients = ({ id }) => {
  const queryClient = useQueryClient();

  const { data, ...rest } = useQuery({
    queryKey: getKeyProductIngredients(id),
    queryFn: async () => {
      const { data } = await getProductIngredients({ productId: id });
      return data;
    },
    enabled: !!id,
    staleTime: 0,
    onError: () => {
      CustomNotification.error('Something went wrong!');
    },
  });

  const refetchProductIngredients = () => {
    queryClient.invalidateQueries({
      queryKey: getKeyProductIngredients(id),
    });
  };

  return {
    data: data?.ingredientGroups || [],
    refetchProductIngredients: refetchProductIngredients,
    ...rest,
  };
};

export const useMutationIngredients = () => {
  const mutation = useMutation({
    mutationFn: saveProductIngredient,
  });

  return mutation;
};
